import { httpClient } from '@/shared/api/httpClient';

export type CategoriaLimpeza =
  | 'ordens'
  | 'vendas'
  | 'clientes'
  | 'pecas'
  | 'servicos'
  | 'financeiro'
  | 'colaboradores';

export type ResumoCategoria = {
  registros: number;
  detalhes: string[];
  /** Quando preenchido, a categoria não pode ser limpa sozinha agora. */
  bloqueio: string | null;
};

export type ResumoLimpeza = Record<CategoriaLimpeza, ResumoCategoria>;

export type ResultadoLimpeza = {
  ordens: number;
  ordensItens: number;
  vendas: number;
  vendasItens: number;
  caixas: number;
  clientes: number;
  veiculos: number;
  pecas: number;
  movimentacoesEstoque: number;
  servicos: number;
  financeiros: number;
  colaboradores: number;
  batidasPonto: number;
};

export const limpezaApi = {
  resumo: () => httpClient.get<ResumoLimpeza>('/api/limpeza/resumo'),
  executar: (categorias: CategoriaLimpeza[]) =>
    httpClient.post<ResultadoLimpeza>('/api/limpeza/executar', { categorias }),
};
